import React from 'react';
import { useParams } from 'react-router-dom';
import { projects } from '../utiles/constant';
import { useEffect } from 'react';
function ProjectDetails() {
  const { id } = useParams();
  const projectId = Number(id);
  const project = projects.find(p => p.id === projectId);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  if (!project) {
    return <div>Project not found</div>;
  }
  return (
    <div className="p-4 md:p-8 lg:px-12 xl:px-28 font-poppins mt-10 max-w-7xl mx-auto">
      <img
        src={project.image}
        alt={project.title}
        className={`w-full h-[350px] sm:h-[450px] md:h-[550px] lg:h-[100%]  rounded-3xl object-contain mb-6 md:mb-10 lg:mb-16 image-border ${project.id === 7 || project.id === 8 || project.id === 9 ? 'h-[350px] sm:h-[450px] md:h-[550px] lg:h-[100%]' : 'h-[350px] sm:h-[450px] md:h-[550px] lg:h-[100%]'} `}
      />
      <h1 className="text-xl sm:text-xl md:text-2xl lg:text-3xl mb-4 font-semibold text-primary pl-2 sm:pl-4 md:pl-6 lg:pl-8">
        {project.title}
      </h1>
      <p className="text-sm sm:text-sm md:text-base mb-4 sm:mb-6 text-primary pl-2 sm:pl-4 md:pl-6 lg:pl-8 font-bold">Project description</p>
      <div className="text-sm sm:text-sm md:text-sm lg:text-sm pl-2 sm:pl-4 md:pl-6 lg:pl-8 text-gray-500">
        {project.details.map((detail, index) => (
          <div key={index}>
            {detail.title && (
              <p className="mb-2 sm:mb-4">{detail.title}</p>
            )}
          </div>
        ))}
      </div>
      <p className="text-sm sm:text-sm md:text-base mb-4 sm:mb-6 text-primary pl-2 sm:pl-4 md:pl-6 lg:pl-8 font-bold">Skills and deliverables</p>

      <p className="text-[10px] pl-2 sm:pl-4 md:pl-6 lg:pl-8">
        <div className="flex flex-wrap gap-2 mt-2">
          {project.languages.map((tech, index) => (
            <div
              key={index}
              className="bg-gray-300 text-primary px-4 py-1 rounded-xl text-sm"
            >
              {tech}
            </div>
          ))}
        </div>
      </p>  
      <p className="text-xs sm:text-xs md:text-sm mb-4 sm:mb-6 text-primary pl-2 sm:pl-4 md:pl-6 lg:pl-8 font-semibold mt-10">Published on: {project.date}</p>

    </div>
  );
}
export default ProjectDetails;
